/* Retro Craft — Build Your Service.
   Pairs with snippets/rc-service-builder.liquid and assets/rc-service-builder.css.

   Selection rules
   - "single" groups allow one choice (clicking the chosen option again clears it).
   - "multi" groups allow any combination.
   - An option's data-includes lists other option titles it already covers, and data-replaces
     lists ones it makes unnecessary. Selecting it clears and locks those options
     ("Included in Full Service" / "Replaced by Region Mod"), so nobody pays for both.
   - data-excludes names options that can't be combined with this one (e.g. a PS2 Slim reshell
     rules out a Fat-only PSU board). They lock as "Not compatible with …".
   - data-requires names options that must be chosen first (e.g. a VA0 voltage mod only
     makes sense with a GDEMU install). Until then the option locks as "Requires …".
   - An option with data-max-qty (e.g. controller servicing) reveals a quantity stepper when
     selected. Its price is per item, and the cart line gets that quantity.
   - An option with data-bundle ("Option|variant id|price;;…", e.g. TMR sticks with PicoFly) swaps
     to a cheaper bundle variant while a named option is chosen. The lowest applicable price wins,
     and that bundle variant is what goes in the cart, so the cart always matches the builder.
   - An option with a required choice (e.g. LED colour) reveals it when selected; Add to
     Cart waits until it is made, and the choice is saved to the order as a line property.

   The pop-up also asks how the console will reach us (post, or drop-off in Bicton, WA). That is
   saved as the "Console delivery" cart attribute, which the order emails read.

   Add to Cart first opens an acknowledgement dialog (console owned, tested and working,
   customer-supplied parts included). All three must be ticked; the wording is then saved
   to the cart as the "Service acknowledgement" attribute (shown in the order confirmation
   email). The order note only carries a drop-off flag, so drop-offs stand out in admin.

   Every line added from one build carries the same hidden `_build` property. That is
   the hook for combined-work discounts later: order/cart logic can group lines by it. */
(function () {
  'use strict';

  function money(cents) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
  }

  function setCartBubble(count) {
    var link = document.querySelector('#cart-icon-bubble') || document.querySelector('a[href$="/cart"]');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      link.appendChild(bubble);
    }
    bubble.innerHTML = '<span aria-hidden="true">' + count + '</span>' +
      '<span class="visually-hidden">' + count + ' item' + (count === 1 ? '' : 's') + '</span>';
  }

  // Meta pixel custom events (the pixel is loaded by the Facebook & Instagram app and may
  // arrive after this script, so wait briefly for it; never let tracking break the builder).
  function metaEvent(name, data, tries) {
    tries = tries || 0;
    try {
      if (typeof window.fbq === 'function') { window.fbq('trackCustom', name, data); return; }
    } catch (e) { return; }
    if (tries < 20) setTimeout(function () { metaEvent(name, data, tries + 1); }, 500);
  }

  function init(root) {
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-opt]'));
    if (!opts.length) return;
    var consoleName = root.dataset.console || 'Service';
    var engaged = false;

    var byTitle = {};
    opts.forEach(function (o) { byTitle[o.dataset.title.trim().toLowerCase()] = o; });

    var list = root.querySelector('[data-list]');
    var empty = root.querySelector('[data-empty]');
    var total = root.querySelector('[data-total]');
    var addBtn = root.querySelector('[data-add]');
    var clearBtn = root.querySelector('[data-clear]');
    var msg = root.querySelector('[data-msg]');
    var hint = root.querySelector('[data-hint]');
    var bar = root.querySelector('[data-bar]');
    var barCount = root.querySelector('[data-bar-count]');
    var barTotal = root.querySelector('[data-bar-total]');
    var barSum = root.querySelector('[data-bar-sum]');
    var barStatus = root.querySelector('[data-bar-status]');
    var barState = null; // 'adding' | 'added' | 'error' while the mobile bar shows cart feedback
    var tally = root.querySelector('.rc-sb__tally');
    var tallyVisible = false;
    var ack = root.querySelector('[data-ack]');
    var ackBoxes = ack ? Array.prototype.slice.call(ack.querySelectorAll('[data-ack-box]')) : [];
    var ackConfirm = ack && ack.querySelector('[data-ack-confirm]');
    var ackSupplies = ack && ack.querySelector('[data-ack-supplies]');
    var ackSd = ack && ack.querySelector('[data-ack-sd]');
    function activeBoxes() { return ackBoxes.filter(function (b) { return !b.closest('[hidden]'); }); }
    function deliveryOf() { var r = ack && ack.querySelector('[data-delivery]:checked'); return r ? r.value : ''; }
    function allTicked() { return activeBoxes().every(function (x) { return x.checked; }) && !!deliveryOf(); }

    function isOn(o) { return o.getAttribute('aria-pressed') === 'true'; }
    function choiceBox(o) { var w = o.closest('.rc-sb-optwrap'); return w && w.querySelector('[data-choice]'); }
    function choiceOf(o) {
      var box = choiceBox(o);
      var picked = box && box.querySelector('input:checked');
      return picked ? picked.value : '';
    }
    function setOn(o, on) {
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
      var qb = qtyBox(o);
      if (qb) {
        qb.hidden = !on;
        o.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (!on) setQty(o, 1);
      }
      var box = choiceBox(o);
      if (!box) return;
      box.hidden = !on;
      o.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on) {
        box.querySelectorAll('input').forEach(function (i) { i.checked = false; });
        box.classList.remove('is-missing');
      }
    }
    function qtyBox(o) { var w = o.closest('.rc-sb-optwrap'); return w && w.querySelector('[data-qty]'); }
    function qtyOf(o) { var box = qtyBox(o); return box ? Number(box.querySelector('[data-qty-val]').textContent) || 1 : 1; }
    function setQty(o, n) {
      var box = qtyBox(o); if (!box) return;
      var max = Number(o.dataset.maxQty) || 1;
      n = Math.max(1, Math.min(max, n));
      box.querySelector('[data-qty-val]').textContent = n;
      box.querySelector('[data-qty-step="-1"]').disabled = n <= 1;
      box.querySelector('[data-qty-step="1"]').disabled = n >= max;
    }
    function bundleTier(o) {
      if (!o.dataset.bundle) return null;
      var best = null;
      o.dataset.bundle.split(';;').forEach(function (entry) {
        if (!entry) return;
        var p = entry.split('|');
        var other = byTitle[p[0].trim().toLowerCase()];
        var price = Number(p[2]);
        if (other && isOn(other) && !isNaN(price) && (best === null || price < best.price)) best = { id: Number(p[1]), price: price };
      });
      return best;
    }
    function bundlePrice(o) { var t = bundleTier(o); return t ? t.price : null; }
    function bundled(o) { return bundlePrice(o) !== null; }
    function priceOf(o) { var bp = bundlePrice(o); return bp !== null ? bp : Number(o.dataset.price || 0); }
    function lineTotal(o) { return priceOf(o) * qtyOf(o); }
    // Bundle options: show the offer until it applies, then the reduced price with the old one struck out.
    function updateDeals() {
      opts.forEach(function (o) {
        if (!o.dataset.bundle) return;
        var bp = bundlePrice(o);
        var el = o.querySelector('[data-price-el]');
        var deal = o.querySelector('[data-deal]');
        if (el) el.innerHTML = bp !== null ? '<s class="rc-sb-opt__was">' + money(Number(o.dataset.price)) + '</s> ' + money(bp) : money(Number(o.dataset.price));
        if (deal) deal.hidden = bp === null;
      });
    }
    function needsChoice(o) { return !!choiceBox(o) && !choiceOf(o); }
    function listOf(o, attr) {
      return (o.dataset[attr] || '').split(',')
        .map(function (t) { return byTitle[t.trim().toLowerCase()]; })
        .filter(Boolean);
    }

    // Work out which options a selected option covers or replaces, then lock them.
    function applyIncludes() {
      var coveredBy = new Map();
      opts.forEach(function (o) {
        if (!isOn(o)) return;
        listOf(o, 'includes').forEach(function (x) { coveredBy.set(x, 'Included in ' + o.dataset.title); });
        listOf(o, 'replaces').forEach(function (x) { coveredBy.set(x, 'Replaced by ' + o.dataset.title); });
        listOf(o, 'excludes').forEach(function (x) { coveredBy.set(x, 'Not compatible with ' + o.dataset.title); });
      });
      // Dependencies: lock an option until everything it requires is selected.
      opts.forEach(function (o) {
        if (coveredBy.has(o)) return;
        var missing = listOf(o, 'requires').filter(function (r) { return !isOn(r); });
        if (missing.length) coveredBy.set(o, 'Requires ' + missing.map(function (r) { return r.dataset.title; }).join(' and '));
      });
      opts.forEach(function (o) {
        var note = o.querySelector('[data-included]');
        var by = coveredBy.get(o);
        if (by) {
          setOn(o, false);
          o.disabled = true;
          if (note) { note.textContent = by; note.hidden = false; }
        } else {
          o.disabled = false;
          if (note) { note.textContent = ''; note.hidden = true; }
        }
      });
    }

    function selected() { return opts.filter(isOn); }

    function render() {
      var chosen = selected();
      updateDeals();
      var sum = chosen.reduce(function (s, o) { return s + lineTotal(o); }, 0);

      list.innerHTML = '';
      chosen.forEach(function (o) {
        var li = document.createElement('li');
        var a = document.createElement('span');
        var pick = choiceOf(o);
        var q = qtyOf(o);
        a.textContent = o.dataset.title + (q > 1 ? ' \u00d7 ' + q : '') + (pick ? ' \u2014 ' + pick : '');
        var b = document.createElement('span'); b.textContent = money(lineTotal(o));
        li.appendChild(a); li.appendChild(b);
        list.appendChild(li);
      });

      var missing = chosen.filter(needsChoice);
      // Mobile bar says what is still needed, e.g. "Choose LED colour".
      var barBtn = root.querySelector('[data-bar-add]');
      if (barBtn && !barState) barBtn.textContent = missing.length ? 'Choose ' + (missing[0].dataset.choiceLabel || 'an option') : 'Add to Cart';
      empty.hidden = chosen.length > 0;
      total.textContent = money(sum);
      addBtn.disabled = chosen.length === 0 || missing.length > 0;
      if (hint) {
        hint.hidden = missing.length === 0;
        hint.textContent = missing.map(function (o) {
          return 'Choose ' + (o.dataset.choiceLabel ? 'your ' + o.dataset.choiceLabel : 'an option') + ' for ' + o.dataset.title + '.';
        }).join(' ');
      }
      clearBtn.hidden = chosen.length === 0;

      if (bar && !barState) {
        barCount.textContent = chosen.length + (chosen.length === 1 ? ' item' : ' items');
        barTotal.textContent = money(sum);
        bar.hidden = chosen.length === 0 || tallyVisible || (!!ack && ack.hasAttribute('open'));
      }
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        if (o.disabled) return;
        var group = o.closest('[data-group]');
        var turningOn = !isOn(o);
        if (turningOn && group && group.dataset.mode === 'single') {
          group.querySelectorAll('[data-opt]').forEach(function (other) { if (other !== o) setOn(other, false); });
        }
        setOn(o, turningOn);
        if (msg.textContent) { msg.textContent = ''; msg.classList.remove('is-error'); }
        if (barState === 'added' || barState === 'error') setBar(null);
        applyIncludes();
        render();
        // First option picked on this visit: a stronger intent signal than viewing the page.
        if (turningOn && !engaged) {
          engaged = true;
          var sum = selected().reduce(function (s, x) { return s + lineTotal(x); }, 0);
          metaEvent('ServiceBuilderEngaged', { console: consoleName, option: o.dataset.title, value: Math.round(sum) / 100, currency: 'AUD' });
        }
      });
    });

    // Quantity steppers.
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var o = btn.closest('.rc-sb-optwrap').querySelector('[data-opt]');
        setQty(o, qtyOf(o) + Number(btn.dataset.qtyStep));
        render();
      });
    });
    opts.forEach(function (o) { setQty(o, 1); });

    // Picking a choice updates the tally and clears the "missing" highlight.
    root.querySelectorAll('[data-choice] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var box = input.closest('[data-choice]');
        if (box) box.classList.remove('is-missing');
        render();
      });
    });

    clearBtn.addEventListener('click', function () {
      opts.forEach(function (o) { setOn(o, false); });
      applyIncludes();
      render();
    });

    // Acknowledgements are asked once per console per cart. The record of what was confirmed lives in the hidden cart
    // attribute _service_ack (JSON, one entry per console); the readable "Service acknowledgement" attribute the order
    // email shows is rebuilt from it on every add, so a second or third build never repeats the statements.
    var ACK_KEY = '_service_ack';
    var consoleName = root.dataset.console || 'Service';
    var buildPrefix = consoleName.replace(/\s+/g, '-') + '-';
    function boxText(b) { return b.nextElementSibling.textContent.trim(); }
    function suppliesOf(chosen) {
      return chosen.filter(function (o) { return o.dataset.customerSupplies; })
        .map(function (o) { return o.dataset.title + ' (' + o.dataset.customerSupplies + ')'; });
    }
    function readAck(cart) { try { return JSON.parse(((cart && cart.attributes) || {})[ACK_KEY] || '{}') || {}; } catch (e) { return {}; } }
    // a console's earlier confirmation only counts while that console's services are still in the cart
    function hasBuild(cart) {
      return ((cart && cart.items) || []).some(function (it) { return String((it.properties || {})._build || '').indexOf(buildPrefix) === 0; });
    }
    function ackInfo(chosen) {
      return { lines: activeBoxes().map(boxText), supplies: suppliesOf(chosen), delivery: deliveryOf() };
    }
    function union(a, b) { var out = (a || []).slice(); (b || []).forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); }); return out; }
    function renderAck(all) {
      return Object.keys(all).map(function (c) {
        var r = all[c], lines = (r.lines || []).map(function (t) { return '\u2713 ' + t; });
        if (r.supplies && r.supplies.length) lines.push('Customer-supplied parts: ' + r.supplies.join('; '));
        if (r.delivery) lines.push('Getting the console to us: ' + r.delivery);
        return c + ' service acknowledged ' + new Date(r.at).toLocaleString('en-AU') + ':\n' + lines.join('\n');
      }).join('\n\n');
    }

    // Open / close the pop-up. Older browsers without <dialog> support (e.g. iOS before 15.4)
    // get the same panel as a fixed overlay, so the acknowledgement is never skipped.
    var ackFallback = !!ack && typeof ack.showModal !== 'function';
    function onAckKey(e) { if (e.key === 'Escape') hideAck(); }
    function showAck() {
      if (bar) bar.hidden = true;
      if (!ackFallback) { ack.showModal(); return; }
      ack.setAttribute('open', '');
      ack.classList.add('is-fallback');
      document.addEventListener('keydown', onAckKey);
      var first = ack.querySelector('[data-ack-box]');
      if (first) first.focus();
    }
    function hideAck() {
      if (!ackFallback) { ack.close(); return; }
      ack.removeAttribute('open');
      ack.classList.remove('is-fallback');
      document.removeEventListener('keydown', onAckKey);
      afterAckClose();
    }
    // Return focus without jumping the page: to the mobile bar when it is showing, else Add to Cart.
    function afterAckClose() {
      var bb = root.querySelector('[data-bar-add]');
      var onBar = bar && !bar.hidden && getComputedStyle(bar).display !== 'none';
      (onBar && bb ? bb : addBtn).focus({ preventScroll: true });
      render();
    }

    // Mobile bar feedback while adding, mirroring the desktop button: Adding… → ✓ added + View Cart.
    var barTimer = null;
    function setBar(state, n) {
      barState = state;
      clearTimeout(barTimer);
      if (!bar) return;
      var bb = root.querySelector('[data-bar-add]');
      bar.classList.toggle('is-added', state === 'added');
      bar.classList.toggle('is-error', state === 'error');
      barSum.hidden = state === 'added' || state === 'error';
      barStatus.hidden = !(state === 'added' || state === 'error');
      if (state === 'adding') {
        bar.hidden = false; bb.disabled = true; bb.textContent = 'Adding…';
      } else if (state === 'added') {
        bar.hidden = false; bb.disabled = false; bb.textContent = 'View Cart';
        barStatus.textContent = '\u2713 ' + n + (n === 1 ? ' service' : ' services') + ' added';
        barTimer = setTimeout(function () { setBar(null); }, 4000);
      } else if (state === 'error') {
        bar.hidden = false; bb.disabled = false; bb.textContent = 'Try Again';
        barStatus.textContent = 'Couldn\'t add to cart';
      } else {
        bb.disabled = false;
        render();
      }
    }

    var ackPrev = null;   // "you've already confirmed the rest" line, created on first use
    function openAck(chosen) {
      if (!ack) return addToCart(chosen, null);
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .catch(function () { return {}; })
        .then(function (cart) { prepareAck(chosen, hasBuild(cart) ? (readAck(cart)[consoleName] || null) : null); });
    }
    function prepareAck(chosen, rec) {
      ackBoxes.forEach(function (b) { b.checked = false; var l = b.closest('label'); if (l && l !== ackSd) l.hidden = false; });
      ack.querySelectorAll('[data-delivery]').forEach(function (r) { r.checked = !!(rec && rec.delivery === r.value); });
      if (ackSd) ackSd.hidden = !chosen.some(function (o) { return o.hasAttribute('data-needs-sd'); });
      var supplies = chosen.filter(function (o) { return o.dataset.customerSupplies; });
      var newSupplies = suppliesOf(chosen).filter(function (x) { return !rec || (rec.supplies || []).indexOf(x) < 0; });
      ackSupplies.innerHTML = '';
      supplies.forEach(function (o) {
        var li = document.createElement('li');
        li.textContent = o.dataset.title + ': ' + o.dataset.customerSupplies;
        ackSupplies.appendChild(li);
      });
      ackSupplies.hidden = supplies.length === 0;
      // hide the statements already confirmed for this console in this cart (the supplies one returns if new parts are listed)
      var hiddenCount = 0;
      if (rec) ackBoxes.forEach(function (b) {
        var l = b.closest('label'); if (!l || l.hidden) return;
        var isSupplies = b.value === '3';
        if ((rec.lines || []).indexOf(boxText(b)) >= 0 && !(isSupplies && newSupplies.length)) { l.hidden = true; hiddenCount++; }
      });
      if (rec && newSupplies.length === 0) ackSupplies.hidden = true;
      if (!ackPrev) {
        ackPrev = document.createElement('p'); ackPrev.className = 'rc-sb-ack__intro'; ackPrev.setAttribute('data-ack-prev', '');
        ackPrev.textContent = 'You\u2019ve already confirmed the other statements for this console in this order.';
        var intro = ack.querySelector('.rc-sb-ack__intro'); if (intro) intro.insertAdjacentElement('afterend', ackPrev);
      }
      ackPrev.hidden = hiddenCount === 0;
      ack._chosen = chosen; ack._rec = rec;
      // nothing new to confirm and we already know how the console is getting to us: add straight away
      if (rec && rec.delivery && activeBoxes().length === 0) {
        return addToCart(chosen, { lines: [], supplies: suppliesOf(chosen), delivery: rec.delivery, base: rec }, rec.delivery);
      }
      ackConfirm.disabled = !allTicked();
      showAck();
    }

    if (ack) {
      ackBoxes.forEach(function (b) {
        b.addEventListener('change', function () {
          ackConfirm.disabled = !allTicked();
        });
      });
      ack.querySelectorAll('[data-delivery]').forEach(function (r) {
        r.addEventListener('change', function () { ackConfirm.disabled = !allTicked(); });
      });
      ack.querySelector('[data-ack-cancel]').addEventListener('click', hideAck);
      ack.addEventListener('close', afterAckClose);
      ackConfirm.addEventListener('click', function () {
        if (!allTicked()) return;
        var chosen = ack._chosen || selected();
        var info = ackInfo(chosen);
        info.base = ack._rec || null;
        var delivery = deliveryOf();
        hideAck();
        addToCart(chosen, info, delivery);
      });
    }

    // Mobile bar: same as Add to Cart. If a required choice is missing, take them to it.
    var barAdd = root.querySelector('[data-bar-add]');
    if (barAdd) barAdd.addEventListener('click', function () {
      if (barState === 'added') { location.href = '/cart'; return; }
      if (barState === 'adding') return;
      if (barState === 'error') setBar(null);
      var chosen = selected();
      if (!chosen.length) return;
      var incomplete = chosen.filter(needsChoice);
      if (incomplete.length) {
        var box = choiceBox(incomplete[0]);
        box.classList.add('is-missing');
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = box.querySelector('input');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
        return;
      }
      openAck(chosen);
    });

    addBtn.addEventListener('click', function () {
      var chosen = selected();
      if (!chosen.length) return;
      var incomplete = chosen.filter(needsChoice);
      if (incomplete.length) {
        incomplete.forEach(function (o) { var b = choiceBox(o); if (b) b.classList.add('is-missing'); });
        var first = choiceBox(incomplete[0]).querySelector('input');
        if (first) first.focus();
        return;
      }
      openAck(chosen);
    });

    // Save the acknowledgement as a cart attribute (the single record; the order confirmation
    // email repeats it to the customer). The note carries only a drop-off flag for the team,
    // replaced on each build so it always matches the latest delivery choice.
    var DROP_FLAG = 'DROP-OFF (Bicton, WA): contact the customer to arrange a drop-off time.';
    function saveAck(info, delivery) {
      if (!info) return Promise.resolve();
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var attrs = {};
        var all = readAck(cart), base = info.base || null;
        all[consoleName] = {
          at: new Date().toISOString(),
          lines: union(base && base.lines, info.lines),
          supplies: union(base && base.supplies, info.supplies),
          delivery: info.delivery || (base && base.delivery) || ''
        };
        attrs[ACK_KEY] = JSON.stringify(all);
        attrs['Service acknowledgement'] = renderAck(all);
        if (delivery) attrs['Console delivery'] = delivery;
        var note = (cart.note || '').split(DROP_FLAG).join('').trim();
        if (delivery && /drop-off/i.test(delivery)) note = note ? DROP_FLAG + '\n\n' + note : DROP_FLAG;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs, note: note })
        });
      });
    }

    function addToCart(chosen, ackNote, delivery) {
      var build = (root.dataset.console || 'Service').replace(/\s+/g, '-') + '-' + Date.now().toString(36).toUpperCase();
      var items = [];
      chosen.forEach(function (o) {
        var props = { _build: build };
        var pick = choiceOf(o);
        if (pick) props[o.dataset.choiceLabel || 'Option'] = pick;
        var tier = bundleTier(o);
        items.push({ id: tier ? tier.id : Number(o.dataset.variantId), quantity: qtyOf(o), properties: props });
        // An option can bring a second line with it (e.g. a PSU board plus its fitting).
        if (o.dataset.addonId) items.push({ id: Number(o.dataset.addonId), quantity: 1, properties: { _build: build } });
      });

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      setBar('adding');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return saveAck(ackNote, delivery); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          setCartBubble(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          msg.classList.remove('is-error');
          msg.innerHTML = chosen.length + (chosen.length === 1 ? ' service' : ' services') +
            ' added to your cart. <a href="/cart">View cart</a>';
          addBtn.textContent = 'Added ✓';
          setBar('added', chosen.length);
          // Start fresh for the next console, keeping the confirmation visible.
          opts.forEach(function (o) { setOn(o, false); });
          applyIncludes();
          setTimeout(function () { addBtn.textContent = 'Add to Cart'; render(); }, 1600);
          render();
          addBtn.disabled = true;
        })
        .catch(function () {
          msg.classList.add('is-error');
          msg.textContent = 'Something went wrong adding that to your cart. Please try again.';
          addBtn.textContent = 'Add to Cart';
          addBtn.disabled = false;
          setBar('error');
        });
    }

    // Mobile: show the summary bar only while the full tally is off screen.
    if (bar && tally && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        tallyVisible = entries[0].isIntersecting;
        render();
      }).observe(tally);
    }

    applyIncludes();
    render();
    metaEvent('ServiceBuilderView', { console: consoleName, content_category: 'Console service' });
  }

  function start() { document.querySelectorAll('[data-rc-builder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

// More info pop-ups on builder options: hover or keyboard focus opens on desktop, tap toggles on touch,
// and Escape or a click elsewhere closes. A click pins it open until dismissed.
(function () {
  var refocusing = false; // Escape hands focus back to the link without reopening it
  var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function setOpen(wrap, open) {
    var btn = wrap.querySelector('[data-more-btn]'), pop = wrap.querySelector('[data-more-pop]');
    if (!btn || !pop) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    pop.hidden = !open;
    wrap.classList.toggle('is-open', open);
    if (!open) { wrap.removeAttribute('data-pinned'); return; }
    // Keep the box on screen: right-align it to the card if it would run off the edge, and point the arrow at the link.
    pop.classList.remove('rc-sb-more__pop--end');
    if (pop.getBoundingClientRect().right > document.documentElement.clientWidth - 8) pop.classList.add('rc-sb-more__pop--end');
    var b = btn.getBoundingClientRect(), p = pop.getBoundingClientRect();
    pop.style.setProperty('--rc-more-arrow', Math.max(12, Math.min(p.width - 24, b.left + 14 - p.left)) + 'px');
  }
  function closeAll(except) {
    document.querySelectorAll('[data-more]').forEach(function (w) { if (w !== except) setOpen(w, false); });
  }
  function bind(wrap) {
    var btn = wrap.querySelector('[data-more-btn]'), timer;
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var pinned = wrap.hasAttribute('data-pinned');
      closeAll(wrap);
      if (pinned) { setOpen(wrap, false); } else { setOpen(wrap, true); wrap.setAttribute('data-pinned', ''); }
    });
    if (hoverable) {
      wrap.addEventListener('mouseenter', function () { clearTimeout(timer); closeAll(wrap); setOpen(wrap, true); });
      wrap.addEventListener('mouseleave', function () { if (!wrap.hasAttribute('data-pinned')) timer = setTimeout(function () { setOpen(wrap, false); }, 150); });
    }
    btn.addEventListener('focus', function () { if (!refocusing && btn.matches(':focus-visible')) { closeAll(wrap); setOpen(wrap, true); } });
    wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget) && !wrap.hasAttribute('data-pinned')) setOpen(wrap, false); });
  }
  function start() {
    document.querySelectorAll('[data-more]').forEach(bind);
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-more]')) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-more-btn][aria-expanded="true"]');
      if (open) { closeAll(); refocusing = true; open.focus(); refocusing = false; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
